import { useMemo } from 'react';

import { LookUp } from '@work4all/models/lib/Classes/LookUp.entity';
import { DataRequest } from '@work4all/models/lib/DataProvider';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';
import { LookupType } from '@work4all/models/lib/Enums/LookupType.enum';

const LOOKUP_DATA_FIELDS: LookUp = {
  id: null,
  name: null,
  lookupType: null,
  color: null,
  value: null,
  valueDouble: null,
  textValue: null,
  showAs: null,
  standard: null,
  symbol: null,
  groupView: null,
  objKind: null,
  closedStatus: null,
  hexColorPair: null,
  aboVertragAliasKopftext: null,
  aboVertragAliasNotiz: null,
  isVacationKindForShortTimeWork: null,
  userId: null,
  lookUpId: null,
  insertTime: null,
  updateTime: null,
};

export interface UseLookUpRequestProps {
  lookupType?: LookupType | null;
  id?: number;
}

export function useLookUpRequest({ lookupType, id }: UseLookUpRequestProps) {
  const request: DataRequest = useMemo(
    () => ({
      data: LOOKUP_DATA_FIELDS,
      entity: Entities.lookUp,
      vars: {
        type: lookupType,
        codes:
          typeof id === 'number'
            ? [id]
            : typeof id === 'string'
            ? [parseInt(id)]
            : undefined,
      },
    }),
    [lookupType, id]
  );

  return request;
}
